<template>
  <v-row justify="center">
    <v-dialog v-model="openDialog"
              width="fit-content"
              max-width="400px"
              persistent>
      <v-card v-bind:class="dialogItems.sizeCss">
        <v-card-title class="headline">
          <div class="msgStrong">{{ dialogItems.title }}</div>
        </v-card-title>
        <v-card-text class="text-center">
          <div class="msgStrong" v-bind:class="dialogItems.textCss">{{ dialogItems.text }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
                 v-if="dialogItems.cancelBtnText !== ''"
                 @click="cancelBtn"
                 v-bind:class="dialogItems.cancelCss">
            {{ dialogItems.cancelBtnText }}
          </v-btn>
          <v-btn text
                 v-if="dialogItems.okBtnText !== ''"
                 @click="okBtn"
                 v-bind:class="dialogItems.okCss">
            {{ dialogItems.okBtnText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    props: {
      cardFlag: String,
      openDialog: Boolean,
      dialogItems: {},
      cancelBtn: Function,
      okBtn: Function
    }
  };
</script>

<style scoped="scoped">
  .msgStrong {
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  .text-center {
    text-align: center;
    align-content:center;
  }
  .text-left{
      text-align:left;
  }

  .orange {
    display: inline-block;
    position: relative;
    text-decoration: none;
    color: #FFFFFF;
    padding: 0 1rem;
    line-height: 1.5;
    background-color: orange;
    margin-left: 15px;
    border-radius: 5px;
    height: 30px;
    padding-top: 4px;
  }

  .blue {
    display: inline-block;
    position: relative;
    text-decoration: none;
    color: #FFFFFF!important;
    padding: 0 1rem;
    line-height: 1.5;
    background-color: #08348b!important;
    margin-left: 15px;
    border-radius: 5px;
    height: 30px;
    padding-top: 4px;
  }

  .blue-center {
    display: inline-block;
    position: relative;
    text-decoration: none;
    color: #FFFFFF !important;
    padding: 0 1rem;
    line-height: 1.5;
    background-color: #08348b !important;
    margin-left: 15px;
    border-radius: 5px;
    height: 30px;
    padding-top: 4px;
    align-content:center;
  }

  .white {
    display: inline-block;
    position: relative;
    text-decoration: none;
    border: solid 1px !important;
    padding: 0 1rem;
    line-height: 1.5;
    background-color: white;
    margin-left: 15px;
    border-radius: 5px;
    height: 30px;
    padding-top: 4px;
  }
  .redtext{
      color:red;
      background-color:white;
  }
  .blacktext{
      color:black;
      background-color:white;
  }
  .nomal{
      width:400px;
  }
  .big{
      width:440px;
  }
</style>
